import React, { memo, useState } from "react";
import { formatMoney } from "../../../utils";
import { set } from "firebase/database";
import TradespersonFeeBreakdown from "./TradespersonFeeBreakdown";

/* -------------------- Reusable Row -------------------- */
const FeeRow = memo(({ label, value }) => (
    <div className="d-flex justify-content-between text-sm">
        <span className="font-weight-bold">{label}</span>
        <span className="text-dark font-weight-bold">{value}</span>
    </div>
));

/* -------------------- Instafix Fee -------------------- */
const InstafixFee = memo(({ booking_fee = 0, call_out_fee = 0, vat = 0, total = 0 }) => (
    <li className="list-group-item border-0 p-4 mb-2 bg-gray-200 border-radius-lg">
        <div className="d-flex flex-column gap-2">
            <h6 className="mb-2 text-md">Instafix Fee</h6>

            <FeeRow label="Booking fee" value={formatMoney(booking_fee)} />
            <FeeRow label="Call-out fee" value={formatMoney(call_out_fee)} />
            <FeeRow label="VAT" value={formatMoney(vat)} />
            <FeeRow label="Total" value={formatMoney(total)} />
        </div>
    </li>
));

/* -------------------- Tradesperson Fee -------------------- */
const TradespersonFee = memo(({
    job_id,
    payment_minutes = 0,
    working_minutes = 0,
    ftm_fee = 0,
    materials_cost = 0,
    total_cost = 0,
    job_discount = null
}) => {
    const [isShowTradespersonFeeBreakdown, setIsTradespersonFeeBreakdown] = useState(false);
    const handleShowTradespersonFeeBreakdown = () => setIsTradespersonFeeBreakdown(true);
    const handleCloseTradespersonFeeBreakdown = () => setIsTradespersonFeeBreakdown(false);

    const workingTime =
        working_minutes >= 60
            ? `${(working_minutes / 60).toFixed(1)} hours`
            : `${working_minutes} mins`;

    return (
        <>
            <li className="list-group-item border-0 p-4 mb-2 bg-gray-200 border-radius-lg mt-2">
                <div className="d-flex flex-column gap-2">
                    <div className="d-flex justify-content-between">
                        <h6 className="mb-2 text-md">Tradesperson Fee</h6>
                        <button 
                            type="button" 
                            className="btn btn-icon-only btn-rounded btn-outline-secondary mb-0 ms-2 btn-sm d-flex align-items-center justify-content-center"
                            onClick={handleShowTradespersonFeeBreakdown}
                        >
                            <i className="material-icons text-sm">priority_high</i>
                        </button>
                    </div>

                    <FeeRow label="Working time" value={workingTime} />
                    <FeeRow label="Payment hours" value={`${(payment_minutes / 60).toFixed(1)} hours`} />
                    <FeeRow label="Working hour fee" value={formatMoney(ftm_fee)} />
                    <FeeRow label="Total materials fee" value={formatMoney(materials_cost)} />
                    <FeeRow label="Discount" value={formatMoney(job_discount?.amount)} />
                    <FeeRow label="Total" value={formatMoney(total_cost)} />
                </div>
            </li>

            <TradespersonFeeBreakdown
                show={isShowTradespersonFeeBreakdown}
                onClose={handleCloseTradespersonFeeBreakdown}
                job_id={job_id}
            />
        </>
    );
});

/* -------------------- Billing Information -------------------- */
const BillingInformation = memo(({ job_id, instafix_fee = {}, tradesperson_fee = {} }) => (
    <div className="card h-100">
        <div className="card-header pb-0 px-3">
            <h6 className="mb-0">Billing Information</h6>
        </div>

        <div className="card-body pt-4 p-3">
            <ul className="list-group">
                <InstafixFee {...instafix_fee} />
                <TradespersonFee job_id={job_id} {...tradesperson_fee} />
            </ul>
        </div>
    </div>
));

export default BillingInformation;